module.exports = __webpack_public_path__ + "static/media/Barman.14f32718.jpg";